<template>
  <div :class="style.tabsUnit">
    <slot />
  </div>
</template>

<script lang="ts">
import style from "./InputUnit.module.scss";
import {defineComponent} from "vue";

export default defineComponent({
  name: "InputUnit",
  data() {
    return {
      style
    };
  }
});
</script>
